import {useCallback, useMemo, useState} from 'react';
import {yupResolver} from '@hookform/resolvers/yup';
import {useForm, Resolver} from 'react-hook-form';
import {SignInFormData} from './sign-in-interface';
import {AdminSignInValidator} from './sign-in-validator';

export function useAdminSignInHook(
  onSubmit: (data: SignInFormData) => Promise<void>,
) {
  const {
    register,
    handleSubmit,
    errors,
    formState,
    watch,
  } = useForm<SignInFormData>({
    resolver: yupResolver(AdminSignInValidator) as Resolver<
      SignInFormData,
      object
    >,
    mode: 'onSubmit',
    defaultValues: {
      email: '',
      password: '',
    },
  });

  const submitForm = useCallback(onSubmit, [onSubmit]);
  const [isDisabled, setIsDisabled] = useState(true);
  const {email, password} = watch();

  useMemo(() => {
    email && password ? setIsDisabled(false) : setIsDisabled(true);
  }, [email, password]);

  const isSubmitting = useMemo(() => {
    return formState.isSubmitting;
  }, [formState]);

  const hasError = useMemo(() => {
    return formState.submitCount > 0 && formState.errors;
  }, [formState.errors, formState.submitCount]);

  return {
    register,
    onSubmit,
    errors,
    isSubmitting,
    submitForm,
    handleSubmit,
    hasError,
    isDisabled,
  };
}
